import { AutomationsPresentationV1Node } from 'Automations/automationEditor/types'
import { ConditionalProperties } from 'Automations/nodeDefinitions/conditions'
import type { Condition } from '../../switch.types'
import { getAvailableOperators } from '../getAvailableOperators/getAvailableOperators'

export const getAvailableProperties = ({
  conditionId,
  conditions,
  allProperties,
  nodes
}: {
  conditionId: string
  conditions: Condition[]
  allProperties: ConditionalProperties
  nodes: AutomationsPresentationV1Node[]
}): string[] => {
  const currentCondition = conditions.find(c => c.id === conditionId)
  const siblingConditions = conditions.filter(c => c.id !== conditionId)

  return Object.keys(allProperties).filter(property => {
    if (currentCondition?.property === property) return true

    const propertyDef = allProperties[property]

    if (propertyDef.propertyAvailable) {
      return propertyDef.propertyAvailable({ siblingConditions, nodes })
    }

    const availableOperators = getAvailableOperators({
      conditionId,
      propertyKey: property,
      conditions,
      property: propertyDef
    })

    return availableOperators.length > 0
  })
}
